import truncatePages from "../Helpers/TruncatePages";
import { useEffect, useState } from "react";

const Pagination = ({currentPage, setCurrentPage, totalPages}) => {

	// number of pages to show around active page
	const delta = 2;
	const [pagination, setPagination] = useState([]);

	useEffect(() => {

		setPagination(truncatePages(currentPage, totalPages, delta))

	}, [totalPages, currentPage])

	const renderPages = () => {

		return pagination.map((page) => (
			<li className={`page ${page === currentPage && "current"} ${page === '...' && 'disabled'}`} onClick={() => {if (page !== "...")setCurrentPage(page)}} key={page} tabIndex="0" >
				<span>{page}</span>
			</li>
		))
	}

	return (
		<div className="pagination">
			<ul className="pagination__wrap">
				<li className={currentPage > 1? "pagination__arrow--prev" : '' } onClick={() => {if ( currentPage > 1 ) setCurrentPage(currentPage - 1)}} tabIndex="0">
				</li>

				{renderPages()}

				<li className="pagination__arrow" onClick={() => {if ( currentPage < totalPages ) setCurrentPage(currentPage + 1)}} tabIndex="0" >
				</li>
			</ul>
		</div>
	);
}

export default Pagination;
